/**
 * Nazwy modułów do wyświetlania (VP-256).
 *
 * Ledger `token_usage_events` zapisuje `module_id` każdego modułu, który kiedykolwiek
 * pobrał tokeny — na prodzie jest ich więcej niż mamy tłumaczeń (stories-creator,
 * viralbooster, goals-builder…). Dlatego nieznane id nie jest błędem: humanizujemy je
 * zamiast pokazywać pustkę albo surowy klucz i18n.
 */

/** Moduły z tłumaczeniem w przestrzeni `modules.*`. */
export const MODULE_LABEL_KEYS: Record<string, string> = {
  "offer-builder": "modules.offerBuilder",
  "vsl-creator": "modules.vslCreator",
  "ad-creator": "modules.adCreator",
  "marketing-analyst": "modules.marketingAnalyst",
  "campaign-creator": "modules.campaignCreator",
  "content-creator": "modules.contentCreator",
  "allegro-ads": "modules.allegroAds",
  "reel-creator": "modules.reelCreator",
  "idea-bank": "modules.ideaBank",
  "youtube-mode": "modules.youtubeMode",
};

/** `stories-creator` → `Stories creator`. */
export function humanizeModuleId(moduleId: string): string {
  const spaced = moduleId.replace(/[-_]/g, " ").trim();
  if (!spaced) return moduleId;
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

/**
 * Nazwa modułu dla użytkownika. `translate` to `t` z `react-i18next` — przekazujemy
 * je zamiast wołać hooka, żeby funkcja została czysta i testowalna.
 */
export function resolveModuleLabel(
  moduleId: string | null | undefined,
  translate: (key: string) => string,
  fallback: string
): string {
  if (!moduleId) return fallback;

  const key = MODULE_LABEL_KEYS[moduleId];
  if (!key) return humanizeModuleId(moduleId);

  const translated = translate(key);
  // i18next przy braku klucza oddaje sam klucz — wtedy lepiej pokazać id modułu.
  return translated === key ? humanizeModuleId(moduleId) : translated;
}
